import { render } from "./SpecialtyModulesSettingsOverlay.vue?vue&type=template&id=11ddf14e&scoped=true&lang=pug"
import script from "./SpecialtyModulesSettingsOverlay.vue?vue&type=script&lang=js"
export * from "./SpecialtyModulesSettingsOverlay.vue?vue&type=script&lang=js"

import "./SpecialtyModulesSettingsOverlay.vue?vue&type=style&index=0&id=11ddf14e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ddf14e"]])

export default __exports__